// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HandsPrayingIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m29.415 22.5-4.53-4.531-4.558-15.037A2.721 2.721 0 0 0 16 1.617a2.72 2.72 0 0 0-4.328 1.317L7.115 17.97l-4.53 4.53a2 2 0 0 0 0 2.828l4.086 4.086a1.999 1.999 0 0 0 2.829 0l6.035-6.039a5.1 5.1 0 0 0 .465-.536c.142.19.298.368.465.536l6.035 6.04a2 2 0 0 0 2.829 0l4.086-4.086a2.001 2.001 0 0 0 0-2.829ZM8.085 28 4 23.915l1.586-1.586 4.086 4.086L8.085 28ZM15 19.844a2.98 2.98 0 0 1-.875 2.125L11.085 25 7 20.915l1.706-1.707a1 1 0 0 0 .25-.418l4.625-15.277a.722.722 0 0 1 1.419.21v16.12Zm2.875 2.125A2.981 2.981 0 0 1 17 19.844V3.719a.722.722 0 0 1 1.414-.21l4.625 15.277a1 1 0 0 0 .25.418l1.811 1.811-4.175 4-3.05-3.046ZM23.915 28l-1.57-1.571 4.174-4L28 23.915 23.915 28Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
